import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import styled from "styled-components";
import theme from '../theme/theme'
import { Typography } from "@plum-xoxo/admin-dsm";

const StyledReactQuill = styled(ReactQuill).attrs()`
  width: 100%;
 
  .ql-toolbar.ql-snow, .ql-container.ql-snow {
    border: 1px solid ${(props) => props.error ? `${theme.palette.error.c03}` : "#E0E4E9"};
  }
  .ql-container p {
    font-size:16px;
    color: ${theme.palette.dark.c300};
  }
  .ql-toolbar{
    border-top-left-radius:4px;
    border-top-right-radius:4px;
  }
  .ql-container{
    border-bottom-left-radius:4px;
    border-bottom-right-radius:4px;
  }
  .ql-editor{
    height: ${(props) => (props.height ? `${props.height}px` : "auto")};
    word-break: break-all;
    
  }
  button.ql-active{
    color:red !important;
  }
  p{
    margin: 0;
  }
  .ql-tooltip{
    left: 50% !important;
    transform: translateX(-50%);
  }
`;

const ReactQuillEditor = ({ value = "", onChange, limit = 100, height = 0 }) => {
  const [error, setError] = useState(false)
  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      ["link"],
      ["clean"],
    ],
  };

  const formats = ["bold", "italic", "underline", "link"];

  const getPlainText = (value) => {
    const plainText = new DOMParser().parseFromString(value, 'text/html').body.textContent || '';
    return plainText
  }

  return (
    <div className="w-100">
      <StyledReactQuill
        theme="snow"
        modules={modules}
        formats={formats}
        onChange={(newValue) => {
          if (getPlainText(newValue).length <= limit) {
            onChange(newValue)
          } else {
            onChange(value)
            setError(true)
            setTimeout(() => {
              setError(false)
            }, 1000)
          }
        }}
        value={value}
        height={height}
        error={error}
      ></StyledReactQuill>
      <div className="d-flex justify-content-between">
        <Typography.BodySmall className="mt-4" color="error" shade="c03">
          {error ? "Max limit reached" : ""}
        </Typography.BodySmall>
        <Typography.BodySmall className="mt-4" color="dark" shade="c200">{getPlainText(value).length}/{limit}</Typography.BodySmall>
      </div>
    </div>
  );
};

export default ReactQuillEditor;
